import { render, staticRenderFns } from "./EditPostModal.vue?vue&type=template&id=2e6c9b1e&scoped=true&"
import script from "./EditPostModal.vue?vue&type=script&lang=js&"
export * from "./EditPostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c9b1e",
  null
  
)

export default component.exports